
<div class="agpr-bulkActionFormExport">
    <agpr-dropdown
        styleClass="agpr-bulkActionFormExport-dropdown"
        [disabled]="true"
        [options]="fileTypes"
        [(ngModel)]="selectedFileType"
        (ngModelChange)="changed()"
        label="Monitoring.bulk.action.export.exportFileTypeLabel"
    >
    </agpr-dropdown>
</div>
